var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperationsFloodSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 54,
    viewBox: "0 0 47 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_193_4608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1425 7.58862C32.8109 4.25703 28.3796 2.42627 23.6701 2.42627C18.9541 2.42627 14.5292 4.25703 11.1976 7.58862C7.86603 10.9202 6.02881 15.3515 6.02881 20.0611C6.02881 29.59 15.0403 37.5212 19.8856 41.7778C20.5584 42.373 21.1342 42.8841 21.5999 43.311C22.1822 43.8544 22.9261 44.1261 23.6701 44.1261C24.414 44.1261 25.158 43.8544 25.7337 43.311C26.1995 42.8841 26.7817 42.373 27.4545 41.7778C32.2934 37.5212 41.3048 29.59 41.3048 20.0611C41.3048 15.3515 39.4741 10.9202 36.1425 7.58862Z",
    fill: "#E0791A",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0365 12.7974L27.5965 12.856L27.7379 13.918L28.1779 13.8594C28.713 13.7884 29.2658 13.9354 29.6946 14.2634C30.1236 14.5916 30.41 15.0865 30.4816 15.6215L30.5402 16.0615L31.6021 15.9201L31.5435 15.4801C31.435 14.6651 30.9983 13.9117 30.3454 13.4123C29.6929 12.9131 28.8514 12.6889 28.0365 12.7974Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.793 15.7615L33.8547 15.6186L33.8372 15.4906C33.6359 13.9786 32.8586 12.6361 31.6472 11.7094C30.4357 10.7827 28.9367 10.3835 27.4254 10.5851L27.2966 10.602L27.4366 11.6641L27.5662 11.6473C28.7942 11.4837 30.0126 11.808 30.9964 12.5605C31.9801 13.3131 32.6123 14.4037 32.7756 15.6327L32.793 15.7615Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8303 9.39922C29.436 9.36421 31.0228 9.88237 32.2986 10.8583C33.5742 11.8341 34.4897 13.2299 34.8763 14.789L35.0573 15.5184L36.0976 15.2606L35.9164 14.531C35.4719 12.7367 34.4179 11.1297 32.9498 10.0067C31.4817 8.88395 29.6547 8.28759 27.8069 8.3277L27.0549 8.34425L27.0784 9.41577L27.8303 9.39922Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6603 14.7988C18.9339 14.7988 15.0884 18.6444 15.0884 23.3707C15.0884 28.0971 18.934 31.9426 23.6603 31.9426C28.3867 31.9426 32.2321 28.097 32.2321 23.3707C32.2321 18.6443 28.3866 14.7988 23.6603 14.7988ZM22.0529 29.7998H20.9815V28.7283H22.0529V29.7998ZM24.196 29.7998H23.1246V28.7283H24.196V29.7998ZM26.339 29.7998H25.2676V28.7283H26.339V29.7998ZM23.8406 27.121H23.479C22.0996 27.121 20.9809 26.0023 20.9809 24.6228C20.9809 24.1545 21.1127 23.696 21.3607 23.299L23.6596 19.6206L25.9586 23.299C26.2065 23.696 26.3384 24.1547 26.3384 24.6228C26.339 26.0025 25.2203 27.121 23.8406 27.121ZM27.7078 29.7098L27.1137 28.8183C28.9776 27.5759 30.0898 25.4971 30.0898 23.2576C30.0898 19.7747 27.2569 16.9416 23.7738 16.9416H23.5478C20.0649 16.9416 17.2318 19.7746 17.2318 23.2576C17.2318 25.4972 18.3441 27.5757 20.2079 28.8183L19.6124 29.7098C17.4501 28.2686 16.1596 25.8562 16.1596 23.2577C16.1596 19.1838 19.4737 15.8702 23.547 15.8702H23.773C27.8469 15.8702 31.1605 19.1843 31.1605 23.2577C31.1607 25.8554 29.8702 28.268 27.7079 29.7098H27.7078Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_193_4608",
    x: 0.528809,
    y: 0.92627,
    width: 46.2759,
    height: 52.6997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_4608"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_193_4608",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationsFloodSensor);
export default __webpack_public_path__ + "static/media/operationsFloodSensor.4bcce6679bcf7b9fd778b3c8b744c5eb.svg";
export { ForwardRef as ReactComponent };